export const genders = {
    male: "ذكور",
    female: "إناث",
    mixed: "مختلطة"
}